import ADPRefcodeService from "../../../services/admin/ADPRefcodeService";
import ASTInstrumentService from "../../../services/ast/ASTInstrumentService";
import axios from 'axios';
import ASTQrdetService from "../../../services/ast/ASTQrdetService";
import ADPParamService from "../../../services/admin/ADPParamService";


class instrumentService {

    async getClientState(): Promise<any> {
        const clientState = localStorage.getItem('clientState');
        return clientState ? JSON.parse(clientState) : null
    }

    async setSearchParam(recordFilter: any, pathName: any): Promise<any> {
        let param = { recordFilter };
        localStorage.setItem(pathName, JSON.stringify(param));
    }

    async getSearchParam(pathName: any): Promise<any> {
        const searchParam = localStorage.getItem(pathName);
        return searchParam ? JSON.parse(searchParam) : null
    }

    async findAllInstrument(recordFilter: any): Promise<any> {
        return await ASTInstrumentService.findAll(recordFilter);
    }


    async getDropdown(moduleId: string, referenceGroup: string): Promise<any> {
        return await ADPRefcodeService.getDropdownByModuleIdAndReferencegroup(moduleId, referenceGroup);
    }


    async createInstrument(item: any): Promise<any> {
        return await ASTInstrumentService.create(item);
    }

    async updateInstrument(item: any): Promise<any> {
        return await ASTInstrumentService.update(item.instrumentId, item);
    }

    async unassignQr(item: any): Promise<any> {
        return await ASTQrdetService.update(item.qrId, item);
    }

    async deleteInstrument(instrumentId: string): Promise<any> {
        return await ASTInstrumentService.delete(instrumentId);
    }

    async uploadExcelData(data: any[]): Promise<any> {
        return await ASTInstrumentService.uploadExcel(data);
    }

    async findOneQrdet(instrumentId: any): Promise<any> {
        return await ASTQrdetService.getItemsByInstrumentId(instrumentId);
    }

    async getPrinterName(parameterId: string): Promise<any> {
        return await ADPParamService.getItemById(parameterId);
    }
}

export default new instrumentService();
